import * as Scrivito from "scrivito";
import metadataAttributes from "objs/_metadataAttributes";
import defaultPageAttributes from "objs/_defaultPageAttributes";

const WizardItem = Scrivito.provideObjClass("WizardItem", {
  attributes: {
    subType: [
      "enum",
      {
        values: [
          "fireprotection",
          "roomcontrol",
          "roomcontrolwireless",
          "xcube",
          "xfans",
        ],
      },
    ],
    // Tile overview
    tileTitle: "string",
    tileSubtitle: "string",
    tileDescription: "string",
    tileImage: ["reference", { only: "Image" }],
    // WizardLeftSidebar
    menuTitle: "string",
    menuTitleImage: ["reference", { only: "Image" }],
    menuSubtitle: "string",
    menuStepTitles: "stringlist",
    linkForMenuItem: "link",
    imageForProductsNavigation: ["reference", { only: "Image" }],
    // Intro page
    introTitle: "string",
    introSubtitle: "string",
    introText: "string",
    introMedia: ["widgetlist", { only: ["YoutubeVideoWidget", "ImageWidget"] }],
    isProdReady: "boolean",
    ...metadataAttributes,
    ...defaultPageAttributes,
  },
  extractTextAttributes: [],
});

export default WizardItem;
